export default __webpack_public_path__ + "static/media/SCIENCE_SPACE.2409975a.svg";